/* eslint-disable array-callback-return */
/* eslint-disable func-names */
import React, { useContext, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import PropTypes from 'prop-types';
import DateInputPicker3 from 'modules/common/components/DateInputPicker3';
import { withRouter } from 'react-router-dom';
import withForm from 'modules/common/hoc/withForm';
import { ModalContext } from 'App';
import Modal from 'modules/common/components/Modal';
import * as actions from '../actions';
import * as c from '../constants';

function ChangeYear({
  updating,
  changeYear,
  onClear,
  transactionId,
  taxPayerInfoIsPosted
}) {
  const setModal = useContext(ModalContext);
  const [formData, setFormData] = useState({
    year: '',
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    const args = {
      ...formData,
      year: _.get(formData, 'year'),
      transaction_history_id: transactionId
    };

    changeYear(args, () => {
      onClear(e);
      setModal({ isOpen: false });
    });
  };

  const onChangeYear = key => e => {
    setFormData({
      ...formData,
      [key]: e.target.value,
    });
  };

  useEffect(() => {
    setFormData({
      ...formData,
      year: _.get(taxPayerInfoIsPosted, 'year') ? _.get(taxPayerInfoIsPosted, 'year').toString() : ''
    })
  }, [])

  return (
    <Modal.Body>
      <div className="row">
        <div className="col-12 form-group">
          <label className="form-label d-flex align-items-center">
            <span className="mr-auto mr-0 text-muted">Year</span>
          </label>
          <DateInputPicker3
            showYearPicker
            onChange={onChangeYear('year')}
            className="form-control"
            value={_.get(formData, 'year') || ''}
            placeholder="Select Year..."
            defaultShow={false}
            maxDate={new Date()}
          />
        </div>
        <div className="col-12 d-flex justify-content-center mt-2">
          <button
            disabled={updating}
            onClick={handleSubmit}
            type="button"
            className="btn btn-primary cms-bg-color-primary cms-outline-primary "
          >
            Submit
          </button>
        </div>
      </div>
    </Modal.Body>
  );
}

ChangeYear.propTypes = {
  changeYear: PropTypes.instanceOf(Object).isRequired,
  onClear: PropTypes.instanceOf(Function).isRequired,
  updating: PropTypes.bool.isRequired,
  transactionId: PropTypes.string.isRequired,
  taxPayerInfoIsPosted: PropTypes.instanceOf(Object).isRequired
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.CHANGE_YEAR) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(ChangeYear);
